import * as React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { BUCKET_NAME } from "../LandingPage/constants";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function FolderBreadcrumbs({ prefix, gets3Objects }: any) {
    const [breadcrumbList, setbreadcrumbList] = React.useState([]);

    React.useEffect(() => {
        if (prefix == "") {
            setbreadcrumbList([]);
        } else if (prefix) {
            setbreadcrumbList(prefix.split("/"));
        }
    }, [prefix]);

    function handleClick(index: number) {
        console.log(breadcrumbList, index);
        const bclist = [...breadcrumbList];
        bclist.pop();
        const updatedPath = bclist.slice(0, index + 1).join("/");
        gets3Objects(`${updatedPath}/`, false);
    }

    function onClickRoot() {
        gets3Objects("", false);
    }

    function onClickBackButton() {
        const bclist = [...breadcrumbList];
        const updatedPath = bclist.slice(0, bclist.length - 2).join("/");
        gets3Objects(updatedPath ? `${updatedPath}/` : "", false);
    }

    return (
        <div role="presentation">
            <div className="d-flex">
                {breadcrumbList.length > 0 && (
                    <ArrowBackIcon
                        onClick={onClickBackButton}
                        className="breadcrumbs-back"
                    />
                )}

                <Breadcrumbs className="ml-1" aria-label="breadcrumb">
                    <FolderOpenIcon />{" "}
                    <span
                        className="breadcrumbs d-flex"
                        color="inherit"
                        onClick={() => onClickRoot()}
                    >
                        {BUCKET_NAME}
                    </span>
                    {breadcrumbList &&
                        breadcrumbList.map((detail: any, index: number) => {
                            return (
                                <span
                                    key={detail}
                                    className="breadcrumbs"
                                    color="inherit"
                                    onClick={() => handleClick(index)}
                                >
                                    {detail}
                                </span>
                            );
                        })}
                </Breadcrumbs>
            </div>
        </div>
    );
}
